module.exports = __webpack_public_path__ + "static/media/internacional-de-seguros-off-app-provider-icon.45a8a6b6.svg";